var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-button',{on:{"click":_vm.batch}},[_vm._v("批量修改申样门槛")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }